import React from 'react';

const PaymentCancel = () => {
  return <div>Payment was cancelled. Please try again.</div>;
};

export default PaymentCancel;